/**
 * Do not edit directly
 * Generated on Mon, 15 Apr 2024 06:34:27 GMT
 */
const tokens = {
    component: {
        input: {
            backgroundColor: {
                value: "#ffffff",
                type: "color",
            },
            borderColor: {
                value: "#949494",
                type: "color",
            },
            borderWidth: {
                value: "1px",
                type: "dimension",
            },
            borderRadius: {
                value: "4px",
                type: "dimension",
            },
            paddingHorizontal: {
                value: "16px",
                type: "dimension",
            },
            paddingVertical: {
                value: "8px",
                type: "dimension",
            },
            gap: {
                value: "4px",
                type: "dimension",
            },
            color: {
                value: "#1e1e1e",
                type: "color",
            },
            fontSize: {
                value: "1rem",
                type: "dimension",
            },
            lineHeight: {
                value: "1.25rem",
                type: "dimension",
            },
            fontWeight: {
                value: 400,
                type: "fontWeight",
            },
            height: {
                value: "40px",
                type: "dimension",
            },
            withPrefix: {
                paddingLeft: {
                    value: "8px",
                    type: "dimension",
                },
            },
            withPostfix: {
                paddingRight: {
                    value: "8px",
                    type: "dimension",
                },
            },
            large: {
                height: {
                    value: "60px",
                    type: "dimension",
                },
                paddingVertical: {
                    value: "16px",
                    type: "dimension",
                },
            },
            prefix: {
                color: {
                    value: "#676767",
                    type: "color",
                },
                fontSize: {
                    value: "1rem",
                    type: "dimension",
                },
                lineHeight: {
                    value: "1.25rem",
                    type: "dimension",
                },
                fontWeight: {
                    value: 400,
                    type: "fontWeight",
                },
            },
            icon: {
                color: {
                    value: "#1e1e1e",
                    type: "color",
                },
                height: {
                    value: "24px",
                    type: "dimension",
                },
                width: {
                    value: "24px",
                    type: "dimension",
                },
                padding: {
                    value: "8px",
                    type: "dimension",
                },
            },
            hover: {
                borderColor: {
                    value: "#1e1e1e",
                    type: "color",
                },
            },
            active: {
                borderColor: {
                    value: "#1e1e1e",
                    type: "color",
                },
            },
            error: {
                borderColor: {
                    value: "#AF292E",
                    type: "color",
                },
            },
            disabled: {
                color: {
                    value: "#b3b3b3",
                    type: "color",
                },
                borderColor: {
                    value: "#b3b3b3",
                    type: "color",
                },
                icon: {
                    color: {
                        value: "#b3b3b3",
                        type: "color",
                    },
                },
                prefix: {
                    color: {
                        value: "#b3b3b3",
                        type: "color",
                    },
                },
            },
            readonly: {
                backgroundColor: {
                    value: "#e6e6e6",
                    type: "color",
                },
            },
        },
    },
};
export default tokens;
